// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
/* jQuery extensions */

//protect against double clicks @@
$.fn.single_click = function(handler) {
    var self = this;
    var return_false = function() { return false; };
    var proxy_handler = function(event) {
        var caller = this;
        self.unbind('click', proxy_handler);
        self.click(return_false);
        setTimeout(function() {
            self.unbind('click', return_false);
            self.click(proxy_handler);
            // rebind
        },
        1000);
        return handler.call(caller, event);
    };
    return self.click(proxy_handler);
};

// protect against double form submits
$.fn.single_submit = function(timeout) {
    var self = this;
    var submit = self.find("[type=submit]");

    if (!timeout) {
      timeout = 1000;
    }

    self.bind('submit',
        function() {
            submit.attr('disabled', true);
            setTimeout(function() {
                submit.attr('disabled', false);
            }, timeout);
        }
    );
};

// serialize form values as a JSON object suitable for ajax methods
// http://stackoverflow.com/questions/1184624/serialize-form-to-json-with-jquery
$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        // The line- and paragraph-separator characters cause a syntax
        // error when used in JSON strings.
        if (_.isString(this.value)) {
            this.value = this.value.replace(/\u2028|\u2029/g, "");
        }
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
